import React, { Component } from 'react';
import '../../../../styles/components/contact-us.scss';
import HeaderBanner from '../../../common/HeaderBanner';
import i18n from '../../../../i18n';
import submitContact from '../../../../models/contact';
import { toast } from 'react-toastify';
import { Mail, Phone, UserRound } from 'lucide-react';

class ContactPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        full_name: '',
        email: '',
        phone: '',
        message: '',
      },
      errors: {},
      isSubmitting: false,
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      },
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  validateForm = () => {
    const { formData } = this.state;
    const errors = {};

    if (!formData.full_name.trim()) {
      errors.full_name = 'Full name is required';
    }

    if (!formData.email.trim()) {
      errors.email = 'Email address is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Email address is invalid';
    }

    if (!formData.phone.trim()) {
      errors.phone = 'Phone number is required';
    }

    if (!formData.message.trim()) {
      errors.message = 'Message is required';
    }

    return errors;
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    this.setState({ isSubmitting: true });

    try {
      const { formData } = this.state;
      const response = await submitContact(formData);

      if (response.success) {
        toast.success('Message sent successfully!', { autoClose: 2000 });
        this.setState({
          formData: { full_name: '', email: '', phone: '', message: '' },
          isSubmitting: false,
        });
      } else {
        toast.error(response.message || 'Failed to send message');
        this.setState({ isSubmitting: false });
      }
    } catch (err) {
      toast.error('Something went wrong. Please try again.');
      this.setState({ isSubmitting: false });
    }
  };

  render() {
    const { formData, errors, isSubmitting } = this.state;

    return (
      <div className="contact-page">
        <HeaderBanner title={i18n.t('get_in_touch')} subtitle={i18n.t('contact_page_subtitle')} />

        {/* Contact Content */}
        <section className="contact-content">
          <div className="container-l2">
            <div className="contact-grid">
              {/* Contact Information */}
              <div className="contact-info-card">
                <h2 className="section-title">{i18n.t('contact_information')}</h2>

                <div className="info-items">
                  <div className="info-item">
                    <div className="info-icon email-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div className="info-content">
                      <h3 className="info-title">{i18n.t('email_address')}</h3>
                      <p className="info-text">info@mzadcom.sa</p>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="info-icon phone-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
                      </svg>
                    </div>
                    <div className="info-content">
                      <h3 className="info-title">{i18n.t('phone_number')}</h3>
                      <p className="info-text">
                        <span dir="ltr">+966 54 813 9096 <br />
                        +966 54 928 4600 </span>
                      </p>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="info-icon location-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                        <circle cx="12" cy="10" r="3" />
                      </svg>
                    </div>
                    <div className="info-content">
                      <h3 className="info-title">{i18n.t('office_address')}</h3>
                      <p className="info-text">{i18n.t('office_address_info')}</p>
                    </div>
                  </div>
                </div>

                {/* Map Placeholder */}
                <div className="map-container">
                  <div className="map-placeholder">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3576.778493635545!2d50.1722482!3d26.301279899999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e49e764489fd549%3A0xbddf276baddd075b!2z2LTYsdmD2Kkg2YXYstin2K_Zg9mFINmE2K3ZhNmI2YQg2KfZhNmF2LLYp9iv2KfYqiDYp9mE2LDZg9mK2Kk!5e0!3m2!1sen!2som!4v1782112699075!5m2!1sen!2som"
                      className="modern-footer__map-iframe"
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Mzadcom Office Location"
                    ></iframe>
                  </div>
                </div>

                {/* Social Icons */}
                <div className="social-icons">
                  <a
                    href="https://mzadcom.sa"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                    aria-label="Website"
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
                    </svg>
                  </a>
                  <a href="mailto:info@mzadcom.sa" className="social-icon" aria-label="Email">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="4" />
                      <path d="M16 8v5a3 3 0 006 0v-1a10 10 0 10-3.92 7.94" />
                    </svg>
                  </a>
                  <a
                    href="https://api.whatsapp.com/send?phone=96892788822"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                    aria-label="Chat"
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
                    </svg>
                  </a>
                </div>
              </div>

              {/* Contact Form */}
              <div className="contact-form-card">
                <h2 className="section-title">{i18n.t('send_us_a_message')}</h2>

                <form onSubmit={this.handleSubmit} className="contact-form">
                  <div className="form-group-l2">
                    <label htmlFor="full_name">{i18n.t('full_name')}</label>
                    <div className="input-wrapper">
                      <UserRound strokeWidth={1.5} className="input-icon-l2" />
                      <input
                        type="text"
                        id="full_name"
                        name="full_name"
                        className={`form-input-l2 ${errors.full_name ? 'error' : ''}`}
                        placeholder={i18n.t('enter_your_name')}
                        value={formData.full_name}
                        onChange={this.handleInputChange}
                      />
                    </div>

                    {errors.full_name && <div className="field-error">{errors.full_name}</div>}
                  </div>

                  <div className="form-group-l2">
                    <label htmlFor="email">{i18n.t('email_address')}</label>
                    <div className="input-wrapper">
                      <Mail strokeWidth={1.5} className="input-icon-l2" />
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className={`form-input-l2 ${errors.email ? 'error' : ''}`}
                        placeholder="you@example.com"
                        value={formData.email}
                        onChange={this.handleInputChange}
                      />
                    </div>
                    {errors.email && <div className="field-error">{errors.email}</div>}
                  </div>

                  <div className="form-group-l2">
                    <label htmlFor="phone">{i18n.t('phone_number')}</label>
                    <div className="input-wrapper">
                      <Phone strokeWidth={1.5} className="input-icon-l2" />
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        className={`form-input-l2 ${errors.phone ? 'error' : ''}`}
                        placeholder="+1 (555) 000-0000"
                        value={formData.phone}
                        onChange={this.handleInputChange}
                      />
                    </div>
                    {errors.phone && <div className="field-error">{errors.phone}</div>}
                  </div>

                  <div className="form-group-l2">
                    <label htmlFor="message">{i18n.t('message')}</label>
                    <div className="input-wrapper">
                      <textarea
                        id="message"
                        name="message"
                        className={`form-textarea ${errors.message ? 'error' : ''}`}
                        placeholder={i18n.t('how_can_we_help')}
                        rows="5"
                        value={formData.message}
                        onChange={this.handleInputChange}
                      ></textarea>
                    </div>
                    {errors.message && <div className="field-error">{errors.message}</div>}
                  </div>

                  <button
                    type="submit"
                    className="button1 button1-gradient"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? `${i18n.t('sending')}...` : i18n.t('submit_message')}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default ContactPage;
